/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { UnitDependencies } from './dependenciesUnitClass.generated.js';
import { createPlanckMass } from '../../factoriesAny.js';
export var planckMassDependencies = {
  BigNumberDependencies,
  UnitDependencies,
  createPlanckMass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesPlanckMass.generated.js
// module id = 1438
// module chunks = 2